import type { ReactNode } from "react";

import { DefaultConnectionIcon, GoogleConnectionIcon } from "@/assets/icons";

import { SocialConnection } from "./socialUtils";

export const getIcon = (connection?: SocialConnection): ReactNode => {
  return connection?.strategy.toLowerCase() === "google" ? (
    <GoogleConnectionIcon />
  ) : (
    <DefaultConnectionIcon />
  );
};
